import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/AreasPopupLinkForSearchMember';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const AreasSearcher = props => {
  const [areaIds, setAreaIds] = useState(props.area_ids);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      $('form').submit();
    }
  },[shouldSubmit]);

  const url = (() => {
    const path = '/popup/member_areas';
    const data = {
      selected_ids: areaIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedAreaTypes => {
    setAreaIds(selectedAreaTypes.map(area => area.id).join(','));
  };

  const onSubmit = () => {
    setShouldSubmit(true);
  };

  const onChangeAreaIds = event => {
    setAreaIds(event.target.value);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.areas}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={true}
        rootNode={document.querySelector('#popup_area')}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        selectedNames={props.input_area_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}

      />
      <input type="hidden"
             name="q[area_ids]"
             onChange={onChangeAreaIds}
             value={areaIds}
      />
    </>
  );
};

AreasSearcher.propTypes = {
  area_ids: PropTypes.string,  // ie. "1,2,3"
  input_area_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return (
    <>
      <a className="back select-area-btn" onClick={props.onClickCloseButton}>他の条件を選択</a>
      <a className="search search-area-btn" onClick={props.onClickSubmitButton}>この条件で検索</a>
    </>
  );
};

export default AreasSearcher;
